var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("base-app-modal", {
    on: {
      "on-cancel-click": function ($event) {
        return _vm.emit("on-cancel-click")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "content",
        fn: function () {
          return [
            _c("div", { staticClass: "modpack-modal--header" }, [
              _c(
                "div",
                { staticClass: "modpack-modal--image" },
                [_c("base-modpack-image", { attrs: { value: _vm.value } })],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "modpack-modal--content" },
                [
                  _c("strong", { staticClass: "modpack-modal--title" }, [
                    _vm._v(
                      "\n          " + _vm._s(_vm.value.name) + "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "modpack-modal--ram" }, [
                    _vm._v(
                      "\n          " +
                        _vm._s(
                          _vm.i18n.t("general:ram.units.recommended", {
                            units: Math.ceil(_vm.value.ram / 1024),
                            unitName: "GB",
                          })
                        ) +
                        "\n        "
                    ),
                  ]),
                  _vm._v(" "),
                  _c("base-modpack-tag-list", {
                    attrs: { tags: _vm.state.tags, "mod-tags": _vm.value.tags },
                  }),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "modpack-modal--text" }, [
              _vm._v(
                "\n      " +
                  _vm._s(
                    _vm.i18n.t(
                      _vm.value.description_key.namespace +
                        ":" +
                        _vm.value.description_key.key,
                      " "
                    )
                  ) +
                  "\n    "
              ),
            ]),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "a",
              {
                staticClass: "button button--tiny modpack-modal--button",
                attrs: { href: _vm.stepOneRoute.href },
              },
              [
                _vm._v(
                  "\n      " +
                    _vm._s(_vm.i18n.t("landingpage:modpack.button.get")) +
                    "\n    "
                ),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }